import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {repeat} from 'lit/directives/repeat.js';
import "./view-post.js";
import "./single-post.js";
import { connect } from 'pwa-helpers/connect-mixin.js';
import store from '../src/store';
import { setElementTheme } from '../components/slds-system';
import { SldsBaseElement } from '../components/slds-base-element.js';
import { setUser, resetStateField, fetchNextPageEvent, playVideo } from '../src/store';
import { fetchProfileData, fetchPosts, fetchTags } from '../src/apiActions';

@customElement('main-view')
class MainView extends connect(store)(SldsBaseElement) {
  @property({type: String}) postOpen = '';

  @property({type: Object}) postObj = null;

  @property({type: String}) route = '';

  @property({type: Boolean}) mobileMode;

  @property({type: Array}) items = [];

  @property({type: Boolean}) loading = false;

  @property({type: Array}) stencils = [1,1,2,2,3,3,4,4,5,5,6,6,7,7];

  @property({type: Array}) searchAfter = [];

  @property({type: Number}) lastForceRedraw = null;

  @property({type: String}) theme = '';

  @property({type: Object}) authUser = null;

  @property({type: Array}) tags = [];

  @property({type: Boolean}) noMoreResults = false;

  @property({type: Array}) categories = [];

  @property({type: String}) mainType = '';

  @property({type: String}) loadedType = '';

  @property({type: String}) mainId = '';

  @property({type: String}) loadedId = 'not-loaded';

  @property({type: String}) selected = '';

  @property({type: Object}) user = null;

  stateChanged(state) {
    if (state.user) {
      this.user = state.user;
    }
    if (state.posts) {
      this.loading = false;
      this.foundOpenPost = false;
      const posts = [...state.posts]; // clone array
      const newItems = posts.map(hit => {
        if (typeof hit.tags === 'string') {
          hit.tags = [hit.tags];
        }
        // Do not mutate hit.created directly, create a new object instead
        const newHit = {
          ...hit,
          created: new Date(hit.created)
        };
        if (this.postOpen === newHit.url) {
          this.postObj = newHit;
          this.foundOpenPost = true;
        }
        return newHit;
      });
      // if (!this.foundOpenPost) {
      //   this.postObj = null;
      // }
      this.items = [...this.items, ...newItems];
      if (posts.length === 0) {
        this.noMoreResults = true;
      }
      this.requestUpdate("items");
      store.dispatch(resetStateField('posts'));
    }
    if (state.removedPost) {
      this.items = this.items.filter(item => item.id !== state.removedPost.id);
      this.requestUpdate("items");
      store.dispatch(resetStateField('removedPost'));
    }
    if (state.tags) {
      const tags = state.tags;
      // Create name and url for each tag
      const newTags = tags.map(tag => {
        return {
          name: tag.tag,
          url: tag.slug
        };
      });
      this.tags = newTags;
      this.requestUpdate();
      store.dispatch(resetStateField('tags'));
    }
    if (state.forceRedraw && !(state.forceRedraw===this.lastForceRedraw)) {
      this.lastForceRedraw = state.forceRedraw;
      this.requestUpdate();
      return null;
    }
    this.theme = state.theme;
    if (this.theme && this.shadowRoot.getElementById('main-view')) {
      setElementTheme(this.shadowRoot.getElementById('main-view'), this.theme);
    }
    const user = state.user;
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    }
    const route = state.route;
    if (route === 'main') {
      if (!this.loading && !this.noMoreResults && (this.loadedType !== this.mainType || this.loadedId !== this.mainId)) {
        this.items = [];
        this.loadedType = this.mainType;
        if (this.loadedId !== this.mainId) {
          store.dispatch(fetchTags(this.mainId, this.selected, this.user?.adultContent));
        }
        this.loadedId = this.mainId;
        this.loading = true;
        this.searchAfter = [];
        this.noMoreResults = false;
        this.fetchData();
      }
    }
  }

  updated(changedProperties) {
    if (this.requiresNewToken && this.authUser) {
      this.refreshUserToken(this.authUser);
      this.requiresNewToken = false;
    }
    if (this.route === 'main' && (this.loadedType !== this.mainType || this.loadedId !== this.mainId) && !this.loading) {
      this.loadedType = this.mainType;
      if (this.loadedId !== this.mainId) {
        store.dispatch(fetchTags(this.mainId, this.selected, this.user?.adultContent));
      }
      this.loadedId = this.mainId;
      this.items = [];
      this.loading = true;
      this.searchAfter = [];
      this.noMoreResults = false;
      this.fetchData();
    }
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.theme && this.shadowRoot.getElementById('main-view')) {
      setElementTheme(this.shadowRoot.getElementById('main-view'), this.theme);
    }
  }

  getIconSize(size) {
    if (size) {
      return "slds-p-left_small slds-p-right_small small_icon";
    }
    else
    {
      return "slds-p-around_small";
    }
  }

  getTheme() {
    return this.theme;
  }

  selectItem(e) {
    e.preventDefault();
    this.mainType = e.target.innerText.toLowerCase();
    if (this.mainType === 'home') {
      this.mainType = 'main';
    }
    const href = e.target.closest('a').href;
    var selected = href.split("/").pop();
    const type = href.split("/")[3];
    if (selected === "") {
      selected = "/";
    }
    if (type === "tag") {
      if (this.mainId === selected) {
        selected = "";
      }
      selected = "/" + type + (this.mainId ? "/" + this.mainId : "") + (selected ? "/" + selected : "");
    }
    else if (this.mainId) {
      selected = "/interest/" + this.mainId + (this.mainId === selected ? "" : "/" + selected);
    }
    history.pushState({}, null, selected);
    window.dispatchEvent(new CustomEvent('route'));
    this.requestUpdate();
  }

  postVisible(e) {
    const postId = e.detail.id;
    for (var i = this.items.length - 1; i >= 0; i--) {
      if (this.items[i].url === postId) {
        // Play video if intersectionRatio is greater than latest intersectionRatio
        this.items[i].autoPlay = true;
        store.dispatch(playVideo(postId));
      }
      else {
        this.items[i].autoPlay = false;
      }
    }
  }

  static styles = [
    super.styles,
    css`
    :host {
      --background-color2: var(--background-color);
    }
    img {
      width: 24rem;
      height: 100%;
      object-fit: contain;
      margin-left: auto;
      margin-right: auto;
      display: block;
      min-height: 24rem;
    }
    .post {
      height: 21rem;
      background-color: #e5e5e5;
      border-radius: 1rem;
      text-align: center;
      line-height: 18rem;
      font-size: 3rem;
      color: darkgray;
    }
    video {
      height: 28rem;
    }
    .ads {
      background-color: #e5e5e5;
      border-radius: 1rem;
      text-align: center;
      margin-bottom: 1.5rem;
      line-height: 18rem;
      color: rgb(169, 169, 169);
      position: sticky;
      left: 0rem;
      top: 0px;
      height: 100vh;
      margin-top: -6rem;
      margin-right: 1.5rem;
      padding-top: 6rem;
    }
    .tag {
      border-radius: 0.25rem;
      padding: 0.125rem 0.25rem;
    }
    .dark .post-tags .tag {
      background-color: #514f4d;
    }
    .dark .post, .dark .ads {
      background-color: #514f4d;
    }
    .dark .slds-tabs_default__item {
      color: white;
    }
    .dark a {
      color: white;
      // --slds-c-button-color-border: white;
    }
    .dark .post-buttons button {
      color: #c9c7c5;
      --slds-c-button-color-border: #514f4d;
    }
    .dark hr {
      border-top: 1px solid #c9c7c5;
    }
    .dark a:focus, .dark a:hover {
      color: #0176d3;
      text-decoration: none;
    }
    @media only screen and (max-width: 480px) {
      #side_ads {
        display: none;
      }
    }
    .slds-button_outline-brand {
      background-color: #f3f3f3;
    }
    .dark .slds-button_outline-brand {
      background-color: #2b2826;
    }
    span.small_icon {
      padding-top: 0.4rem;
      padding-bottom: 0.4rem;
    }
    span.small_icon>.slds-badge__icon {
      margin-right: -0.1rem;
    }
    single-post {
      --background-color2: var(--background-color);
      --table-hover2: var(--table-hover);
      --text-color2: var(--text-color);
      --border-color2: var(--border-color);
      --input-text-color2: var(--input-text-color);
    }
    `
  ];

  render() {
    return html`
      <div class="slds-grid" id="main-view">
        <div class="slds-col slds-medium-size_1-of-1 slds-large-size_2-of-3 ${this.mobileMode ? '' : 'slds-p-left_xx-large slds-p-right_xx-large'}">
          ${html`
          <div class="slds-tabs_default slds-m-top_small slds-m-bottom_large slds-text-heading_small ${this.mobileMode ? 'slds-p-left_large slds-p-right_large' : ''}">
            <ul class="slds-tabs_default__nav" role="tablist">
              <li class="slds-tabs_default__item ${this.mainType === 'main' ? 'slds-is-active' : ''}" title="Home" role="presentation">
                <a class="slds-tabs_default__link" href="${this.mainId ? (this.selected === "tag" ? '/tag/' : '/interest/') + this.mainId : '/'}" @click="${this.selectItem}" role="tab" tabindex="0" aria-selected="true" aria-controls="tab-default-1" id="tab-default-1__item">Home</a>
              </li>
              <li class="slds-tabs_default__item ${this.mainType === 'top' ? 'slds-is-active' : ''}" title="Top" role="presentation">
                <a class="slds-tabs_default__link" href="${this.mainId ? (this.selected === "tag" ? '/tag/' : '/interest/') + this.mainId + '/top' : '/top'}" @click="${this.selectItem}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-2" id="tab-default-2__item">Top</a>
              </li>
              <li class="slds-tabs_default__item ${this.mainType === 'trending' ? 'slds-is-active' : ''}" title="Trending" role="presentation">
                <a class="slds-tabs_default__link" href="${this.mainId ? (this.selected === "tag" ? '/tag/' : '/interest/') + this.mainId + '/trending' : '/trending'}" @click="${this.selectItem}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-3" id="tab-default-3__item">Trending</a>
              </li>
              <li class="slds-tabs_default__item ${this.mainType === 'fresh' ? 'slds-is-active' : ''}" title="Fresh" role="presentation">
                <a class="slds-tabs_default__link" href="${this.mainId ? (this.selected === "tag" ? '/tag/' : '/interest/') + this.mainId + '/fresh' : '/fresh'}" @click="${this.selectItem}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-4" id="tab-default-4__item">Fresh</a>
              </li>
            </ul>
          </div>`}
          <div class="slds-m-bottom_small ${this.mobileMode ? 'slds-p-left_large slds-p-right_large' : ''}">
            ${repeat(
                this.tags,
                (item) => html`<a @click="${this.selectItem}" class="slds-badge tag slds-m-bottom_x-small slds-text-heading_small" href="/tag/${item.url}"><span>${item.name}</span></a>`
            )}
          </div>
          <div>
            ${repeat(
                this.items,
                (val) => html`<single-post .mobileMode="${this.mobileMode}" .categories="${this.categories}" .postOpen='${this.postOpen}' @dialog-opened='${this.viewPostOpened}' @post-visible='${this.postVisible}' .item="${val}"></single-post>`
            )}
          </div>
          ${this.loading ? repeat(
              this.stencils,
              (index, item) => html`<div class="post slds-m-bottom_large ${this.mobileMode ? 'slds-m-left_large slds-m-right_large' : ''}" style=${`opacity: ${(20-index)/20}`}></div>`
          ) : this.noMoreResults ? html`<div class="slds-text-align_center slds-m-top_x-large slds-m-bottom_large slds-text-heading_medium">No more results</div>` : html``}
        </div>
        <div class="slds-col slds-show_large slds-large-size_1-of-3">
          <div class="ads">ADS</div>
        </div>
      </div>
      ${this.postOpen==''?'':html`<view-post .mobileMode="${this.mobileMode}" .categories="${this.categories}" id='${this.postOpen}' .item='${this.postObj}' @dialog-closed='${this.viewPostClosed}'></view-post>`}
    `
  }

  viewPostOpened(e) {
    const postId = e.detail.id;
    store.dispatch(playVideo(""));
    history.pushState({}, null, '/post/'+postId);
    this.postOpen = e.detail.id;
    for (var i = this.items.length - 1; i >= 0; i--) {
      if (this.items[i].url === this.postOpen) {
        this.postObj = this.items[i];
      }
    }
  }

  viewPostClosed() {
    this.postOpen = '';
    document.body.classList.remove("modal-open");
  }

  handleScroll() {
    const endOfPage =
      window.pageYOffset >= (document.body.offsetHeight - window.innerHeight) * 0.7;
    if (this.route === "profile") {
      if (endOfPage) {
        store.dispatch(fetchNextPageEvent(true));
      }
      return null;
    }
    if (!(this.route === "main")) { return null; }
    if (endOfPage && !this.loading && !this.noMoreResults) {
      this.loading = true;
      this.searchAfter = this.items[this.items.length-1].sortBy;
      this.fetchData();
    }
  }

  fetchData() {
    console.log("Fetching new data");
    const myReq = {};
    if (this.searchAfter.length > 0) {
      myReq['lastSort'] = JSON.stringify(this.searchAfter);
    }
    if (this.mainType && this.mainType !== 'main') {
      myReq['type'] = this.mainType;
    }
    if (this.selected === "tag") {
      myReq['tag'] = this.mainId;
    }
    else if (this.mainId) {
      myReq['category'] = this.mainId;
    }
    if (this.user && this.user.adultContent) {
      myReq['degen'] = true;
    }
    this.loadedType = this.mainType;
    const params = String(new URLSearchParams(myReq));
    store.dispatch(fetchPosts(params));
  }

  throttle(callback, time) {
    if (this.throttleWait) return;
    this.throttleWait = true;

    setTimeout(() => {
      callback();
      this.throttleWait = false;
    }, time);
  }

  constructor() {
    super();
    this.throttleWait = false;
    window.addEventListener("scroll", (() => {
      this.throttle(this.handleScroll.bind(this), 150);
    }).bind(this));

    const user = localStorage.getItem("user");
    if (user) {
      const myUser = JSON.parse(user);
      store.dispatch(setUser(myUser));
      store.dispatch(fetchProfileData());
    }
  }
}